import React, {PureComponent, PropTypes} from 'react';
import Modal from 'react-modal';
import cx from 'classnames';
import style from './login-form.module.css';
import modalStyle from '../modal.module.css';
import PasswordReset from './password-reset.react';

class LoginForm extends PureComponent {

    static propTypes = {
        onClose: PropTypes.func,
        open: PropTypes.bool,
        init: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    _resetState() {
        this.setState({
            error: '',
            loading: false,
            success: false,
            reset: false
        });
    }

    _submitReset = (e) => {
        e.preventDefault();

        if (this.state.loading) {
            return;
        }

        this.setState({
            error: '',
            loading: true
        });

        fetch('/auth/reset/', {
            credentials: 'same-origin',
            method: 'post',
            body: new FormData(e.target),
            headers:{'X-CSRF-TOKEN': Exanimo.CSRF}
        }).then((response) => {

            if (response.status !== 200) {
                throw new Error(Exanimo.trans('auth_failed'));
            }

            return response.json();
        }).then((data) => {
            if (data.ok) {
                this.setState({
                    success: true,
                    loading: false
                });
            } else {
                throw new Error(data.error);
            }
        }).catch((err) => {
            this.setState({
                error: err.message,
                loading: false
            });
        });
    }

    _submitForm = (e) => {
        e.preventDefault();

        if (this.state.loading) {
            return;
        }

        this.setState({
            error: '',
            loading: true
        });

        fetch('/auth/login/', {
            credentials: 'same-origin',
            method: 'post',
            body: new FormData(this._form),
            headers:{'X-CSRF-TOKEN': Exanimo.CSRF}
        }).then((response) => {
            
            if (response.status !== 200) {
                throw new Error(Exanimo.trans('auth_failed'));
            }

            return response.json();
        }).then((data) => {
            if (data.ok) {
                document.location = '/';   
            } else {
                throw new Error(data.error);
            }
        }).catch((err) => {
            this.setState({
                error: err.message,
                loading: false
            });
        });
    }

    _passwordResetToggle = (e) => {

        e.preventDefault();

        this.setState({
            reset: !this.state.reset,
            success: false,
            error: ''
        });
    }

    componentWillReceiveProps(props) {
       if (props.init) {
            this._resetState();
       }
    }

    render() {
        const customStyles = {
            overlay : {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                zIndex: 2
            },
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                backgroundColor       : '#F1F1F1',
                color                 : '#333333',
                padding               : '0'
            }
        };

        const error = (this.state.error) ? <div className={style.error}>{this.state.error}</div> : '';
        const loginButtonText = (this.state.loading) ? '. . .' :  Exanimo.trans('login');

        //<a href="/auth/steam/redirect" className={cx(style.button, style.steam)}>steam</a>

        return (

            <Modal
                isOpen={this.props.open}
                onRequestClose={this.props.onClose}
                contentLabel="LoginForm"
                style={customStyles}
            >
                <div className={style.container}>
                    <a href="" onClick={this.props.onClose} className={modalStyle.close}/>

                    {
                        this.state.reset &&
                        <PasswordReset
                            onSubmit={this._submitReset}
                            success={this.state.success}
                            error={this.state.error}
                            loading={this.state.loading}
                        />
                    }

                    {
                        (!this.state.reset &&
                        <div className={style.left}>
                            <h2 className={style.smallHeader}>{Exanimo.trans('login')}</h2>

                            <div className={style.buttonContainer}>
                                <a href="/auth/facebook/redirect" className={[style.facebookButton, style.socialButton].join(' ')}>
                                    <div className={style.socialButtonInnerWrapper}>
                                        <div className={style.socialButtonIconWrapper}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 90 90"><g><path d="M90,15.001C90,7.119,82.884,0,75,0H15C7.116,0,0,7.119,0,15.001v59.998   C0,82.881,7.116,90,15.001,90H45V56H34V41h11v-5.844C45,25.077,52.568,16,61.875,16H74v15H61.875C60.548,31,59,32.611,59,35.024V41   h15v15H59v34h16c7.884,0,15-7.119,15-15.001V15.001z" fill="#FFFFFF"></path></g></svg>
                                        </div>
                                        <div className={style.socialButtonSpacer}></div>
                                        <div className={style.socialButtonTextWrapper}>{Exanimo.trans('log_in_with_facebook')}</div>
                                    </div>
                                </a>
                                <a href="/auth/discord/redirect?action=login" className={[style.discordButton, style.socialButton].join(' ')}>
                                    <div className={style.socialButtonInnerWrapper}>
                                        <div className={style.socialButtonIconWrapper}>
                                            <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF" width="26px" height="26px"><title>Discord icon</title><path d="M20.222 0c1.406 0 2.54 1.137 2.607 2.475V24l-2.677-2.273-1.47-1.338-1.604-1.398.67 2.205H3.71c-1.402 0-2.54-1.065-2.54-2.476V2.48C1.17 1.142 2.31.003 3.715.003h16.5L20.222 0zm-6.118 5.683h-.03l-.202.2c2.073.6 3.076 1.537 3.076 1.537-1.336-.668-2.54-1.002-3.744-1.137-.87-.135-1.74-.064-2.475 0h-.2c-.47 0-1.47.2-2.81.735-.467.203-.735.336-.735.336s1.002-1.002 3.21-1.537l-.135-.135s-1.672-.064-3.477 1.27c0 0-1.805 3.144-1.805 7.02 0 0 1 1.74 3.743 1.806 0 0 .4-.533.805-1.002-1.54-.468-2.14-1.404-2.14-1.404s.134.066.335.2h.06c.03 0 .044.015.06.03v.006c.016.016.03.03.06.03.33.136.66.27.93.4.466.202 1.065.403 1.8.536.93.135 1.996.2 3.21 0 .6-.135 1.2-.267 1.8-.535.39-.2.87-.4 1.397-.737 0 0-.6.936-2.205 1.404.33.466.795 1 .795 1 2.744-.06 3.81-1.8 3.87-1.726 0-3.87-1.815-7.02-1.815-7.02-1.635-1.214-3.165-1.26-3.435-1.26l.056-.02zm.168 4.413c.703 0 1.27.6 1.27 1.335 0 .74-.57 1.34-1.27 1.34-.7 0-1.27-.6-1.27-1.334.002-.74.573-1.338 1.27-1.338zm-4.543 0c.7 0 1.266.6 1.266 1.335 0 .74-.57 1.34-1.27 1.34-.7 0-1.27-.6-1.27-1.334 0-.74.57-1.338 1.27-1.338z"></path></svg>
                                        </div>
                                        <div className={style.socialButtonSpacer}></div>
                                        <div className={style.socialButtonTextWrapper}>{Exanimo.trans('log_in_with_discord')}</div>
                                    </div>
                                </a>
                            </div>

                            <form ref={(formNode) => this._form = formNode} onSubmit={this._submitForm} action="">
                                {error}
                                <input className={style.loginInput} ref={(node) => this._emailNode = node} type="email" placeholder={Exanimo.trans('email')} name="email"/>
                                <input className={style.loginInput} ref={(node) => this._passwordNode = node} type="password" placeholder={Exanimo.trans('password')} name="password"/>
                                <br/>
                                <input className={style.loginSubmit} type="submit" value={loginButtonText}/>
                                <a href="" onClick={this._passwordResetToggle} className={style.passwordReset}>{Exanimo.trans('password_reset')}</a>
                            </form>
                        </div>)
                    }

                    <div className={style.right}>
                        <h2 className={style.noAccountHeader}>{Exanimo.trans('no_account')}</h2>
                        <p className={style.noAccountText}>{Exanimo.trans('no_account_text')}</p>
                        <a href="/auth/register" className={modalStyle.button}>{Exanimo.trans('register')}</a>
                    </div>
                </div>
            </Modal>);
    }
}

export default LoginForm;